import { Injectable } from '@angular/core';
import { AppSection } from '../../domain/app-section.model';
import { APP_SECTIONS } from '../../domain/app-sections.registry';
import { TopToolbarStrategyFactory } from '../../ports/toolbar-strategy-factory.port';
import { TopToolbarStrategy } from '../../ports/toolbar-strategy.port';

@Injectable()
export class LazyToolbarStrategyFactoryAdapter implements TopToolbarStrategyFactory {
  async createStrategy(section: AppSection): Promise<TopToolbarStrategy | null> {
    const sectionConfig = APP_SECTIONS[section];

    if (!sectionConfig) {
      return null;
    }

    const strategyModule = await sectionConfig.strategy();
    return new strategyModule.default();
  }
}
